import React, { useContext } from 'react';
import { DataManager, NavigationBarContext } from '@bit-by-bit-software/ui';
import { HomeProps } from './Home.types';
import { HomeContainer } from './Home.styles';


function Home({ sendRequest, token }: HomeProps) {
  const { selectedNavItem } = useContext(NavigationBarContext);
  return (
    <HomeContainer>
      {selectedNavItem !== null && token ? <DataManager model={selectedNavItem} sendRequest={sendRequest} token={token} /> : null}
    </HomeContainer>
  );
}

export default Home;
